module.exports = __webpack_public_path__ + "static/media/cert_992019012.17b536e1.jpg";